export default "__VITE_ASSET__e3l8jST8__"